import React, { useEffect } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { ToastContainer } from "react-toastify";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { useNavigate } from "react-router-dom";
import { useAuthPersistState } from "@/store/auth/auth.store";
import { collectionDoc } from "@/api/collectionRef/collectionOperations";
import Consent from "@/components/Consent/Consent";
import i18next from "i18next";
import { Box, Button, Container, Dialog, Flex, Text } from "@radix-ui/themes";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy/PrivacyPolicy";
import { themeMap } from "@/utils/constants/Themes";

export default function UnAuthorizedLayout({
  children,
  user,
}: {
  children: React.ReactNode;
  user?: boolean;
}) {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const setProfile = useCurrentUserProfile((s) => s.setUser);
  const userAuth = useAuthPersistState((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });

    if (!userAuth && currentUser) {
      // return setProfile(null); // Remove profile from storage
    }

    if (currentUser) {
      return navigate("/dashboard");
    }

    async () => {
      const profileRef = await collectionDoc.profiles(
        userAuth.uid,
        brand.tenantId
      );
      const profile = profileRef.data();
      if (userAuth && !profile.userName) {
        return navigate("/enter-username");
      }
    };
  }, [currentUser, userAuth]);
  const theme = themeMap[brand.brandValue] || "violet"; // Fallback to a default theme if brandValue is not found

  return (
    <Box as="div" className="authentication">
      <Flex justify="center" align="center" minHeight="100vh">
        <Consent
          layout={brand.brandValue === "ELGIGANTEN" ? "small" : "default"}
        />
        <Box>
          <Container size="1">
            <Flex justify="center" mb="7">
              <Box maxWidth="275px">
                <img
                  src={brand.logos.large}
                  alt="Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Flex>
            {children}
            <Box px="5">
              <Text size="1">
                <Text color="gray">{i18next.t("auth.terms.1")} </Text>
                <Dialog.Root>
                  <Dialog.Trigger>
                    <Text
                      color={theme}
                      style={{ cursor: "var(--cursor-link)" }}
                    >
                      {i18next.t("auth.terms.2")}
                    </Text>
                  </Dialog.Trigger>

                  <Dialog.Content size="4">
                    <Dialog.Title>Terms and Conditions</Dialog.Title>

                    <Box>
                      <PrivacyPolicy />
                    </Box>

                    <Flex gap="3" mt="4" justify="end">
                      <Dialog.Close>
                        <Button variant="soft" color="gray">
                          Close
                        </Button>
                      </Dialog.Close>
                    </Flex>
                  </Dialog.Content>
                </Dialog.Root>{" "}
                <Text color="gray">{i18next.t("auth.terms.3")} </Text>
                <Dialog.Root>
                  <Dialog.Trigger>
                    <Text
                      color={theme}
                      style={{ cursor: "var(--cursor-link)" }}
                    >
                      {i18next.t("auth.terms.4")}
                    </Text>
                  </Dialog.Trigger>

                  <Dialog.Content size="4">
                    <Dialog.Title>Privacy Policy</Dialog.Title>

                    <Box>
                      <PrivacyPolicy />
                    </Box>

                    <Flex gap="3" mt="4" justify="end">
                      <Dialog.Close>
                        <Button variant="soft" color="gray">
                          Close
                        </Button>
                      </Dialog.Close>
                    </Flex>
                  </Dialog.Content>
                </Dialog.Root>{" "}
                <Text color="gray">{i18next.t("auth.terms.5")}</Text>
              </Text>
            </Box>
          </Container>
        </Box>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          theme="dark"
          limit={3}
        />
      </Flex>
    </Box>
  );
}
